module.exports = __webpack_public_path__ + "img/Stairs.ea86c640.png";